/* tslint:disable */
/* eslint-disable */
/**
 * Retail Media AdTech - AdServer 2.0
 * The AdServer API is the service that acts as a wrapper for the 3rd party Kevel AdBrain and orchestrates / combines the different dataSources.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redteclab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export const ContextDataPageTypeEnum = {
    Product: 'product',
    Homepage: 'homepage',
    Search: 'search',
    Category: 'category',
    Checkout: 'checkout',
    Marketing: 'marketing',
    Newsletter: 'newsletter',
    Cartintermediate: 'cartintermediate',
    Cart: 'cart',
    Login: 'login',
    Account: 'account',
    Notepad: 'notepad',
    OrdersList: 'orders_list',
    Redpoints: 'redpoints',
    InteractionResult: 'interaction_result',
    Interaction: 'interaction',
    Error: 'error',
    Default: 'default',
    NewsletterUnsubscribe: 'newsletter_unsubscribe'
};
